import { authenticateWithGoogle } from './googleDriveAuth';
class GoogleAuthManager {
    static async getToken() {
        if (this.token) {
            return this.token;
        }
        const authResult = await authenticateWithGoogle();
        if (authResult.success && authResult.token) {
            this.token = authResult.token;
            return this.token;
        }
        throw new Error('No se pudo obtener token de autenticación');
    }
    static setToken(token) {
        this.token = token;
    }
    static hasToken() {
        return this.token !== null;
    }
}
GoogleAuthManager.token = null;
export default GoogleAuthManager;
